import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { AboutUsComponent } from './about-us.component';
import {CmsPageComponent} from "../../shared/components/cms-page/cms-page.component";
import {CmsService} from "../../core/services/cms.service";

const routes: Routes = [{
  path: "",
  children: [
    {
      path: "",
      component:AboutUsComponent
    },
    {
      path: '**',
      component: CmsPageComponent,
      resolve: {
        cmsContent: CmsService
      }
    }
  ]
}];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class AboutUsRoutingModule { }
